var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.plugin)?_c('plugin-layout',[(_vm.loading)?[_c('c-spinner',{staticClass:"tw-mt-4"})]:[_c('div',{staticClass:"releases"},[_vm._l((_vm.pluginChangelog),function(release,key){return [_c('changelog-release',{key:key,attrs:{"release":release}})]})],2)]],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }